import { useEffect, useState } from 'react'
import ReactGA from 'react-ga4'
import { useLocation } from 'react-router-dom'

const TRACKING_ID = import.meta.env.VITE_APP_GA_ID

export const Analytics = (): JSX.Element | null => {
  const [initialized, setInitialized] = useState(false)
  const location = useLocation()

  /*
   * Initialize analytics
   */
  const initializeAnalytics = () => {
    if (!TRACKING_ID) {
      console.error('No analytics keys found. Analytics will not be tracked.')
      return
    }
    ReactGA.initialize(TRACKING_ID)
  }

  /**
   * Capture page changes when location is ready
   */
  useEffect(() => {
    initializeAnalytics()
    setInitialized(true)
  }, [])

  useEffect(() => {
    if (initialized && location) {
      ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search })
    }
  }, [initialized, location])

  return null
}
